import { z } from "zod";

export const ROLE_OPTIONS = ["CTO", "CEO", "HR", "Recruiter", "Other"] as const;
export type RoleOption = (typeof ROLE_OPTIONS)[number];

export const TEAM_SIZE_OPTIONS = ["1-10", "11-50", "51-200", "200+"] as const;
export type TeamSizeOption = (typeof TEAM_SIZE_OPTIONS)[number];

export const contactSalesSchema = z.object({
  name: z.string().min(1, "Il nome è obbligatorio"),
  company_name: z.string().min(1, "Il nome dell'azienda è obbligatorio"),
  role: z.enum(ROLE_OPTIONS, {
    error: "Il ruolo è obbligatorio",
  }),
  email: z
    .string()
    .min(1, "L'email è obbligatoria")
    .email("Inserisci un indirizzo email valido"),
  phone: z.string().optional(),
  team_size: z.enum(TEAM_SIZE_OPTIONS).optional(),
  message: z.string().optional(),
});

export type ContactSalesFormValues = z.infer<typeof contactSalesSchema>;
